import Tag from "common/Tags/Tag";
import React, { CSSProperties } from "react";
import { useTheme } from "styled-components";
import { MarginTypes } from "@shared/types";
import { getDirectionAndMarginTag } from "@shared/features/bots/utils";

interface MarginTagProps {
  botData?: {
    exchange?: string;
    reverse?: boolean;
    margin_type?: MarginTypes;
    leverage?: number;
  };
  style?: CSSProperties;
}

const MarginTag = ({ botData, style }: MarginTagProps) => {
  const appTheme = useTheme();

  return (
    <Tag
      color={appTheme.colors.primaryBlue}
      style={{ width: "fit-content", ...style }}
    >
      {getDirectionAndMarginTag(botData)}
    </Tag>
  );
};

export default MarginTag;
